import * as React from "react"
export const Svg_025 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={59}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M17.657 59h22.686c3.285 0 6.001-2.521 6.378-5.762H11.28c.377 3.24 3.093 5.762 6.378 5.762Z"
    />
    <path fill="url(#b)" d="M30.7 19.095h3.398v6.487h-3.399v-6.487Z" />
    <path fill="url(#c)" d="M23.902 19.095h3.399v6.487h-3.399v-6.487Z" />
    <path
      fill="url(#d)"
      d="M46.766 6.534C46.766 2.931 43.885 0 40.343 0H17.657c-3.541 0-6.423 2.931-6.423 6.534v43.247h35.532V6.534ZM27.3 44.305h-9.152v-3.457h9.152v3.457Zm0-6.914h-9.152v-3.457h9.152v3.457Zm12.55 6.914h-9.152v-3.457h9.152v3.457Zm0-6.914h-9.152v-3.457h9.152v3.457Zm0-18.296h-2.355v6.487h2.355v3.457H18.149v-3.457h2.355v-6.487h-2.355V13.93L29 7.782l10.85 6.148v5.165Z"
    />
    <path fill="url(#e)" d="M22.12 15.637h13.76L29 11.74l-6.88 3.898Z" />
    <defs>
      <linearGradient
        id="a"
        x1={19.475}
        x2={20.083}
        y1={54.102}
        y2={60.162}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={31.485}
        x2={34.884}
        y1={20.068}
        y2={22.95}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={24.688}
        x2={28.087}
        y1={20.068}
        y2={22.95}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={19.451}
        x2={45.618}
        y1={7.467}
        y2={37.695}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={25.302}
        x2={26.005}
        y1={12.324}
        y2={16.342}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)